export const convertFixedColumnInlineStyleToStyled = (fixedColumnsStyle) => {
    const styles = [];
    fixedColumnsStyle.forEach(({ index, style }) => styles.push(`
      > td:${style.left !== undefined ? 'nth-child' : 'nth-last-child'}(${Math.abs(index)}) {
        position: sticky;
        ${style.left !== undefined ? 'left' : 'right'}: ${style.left !== undefined ? style.left : style.right}px;
        z-index: ${style.zIndex};
      }
    `));
    return styles.join('\n\n');
};
//# sourceMappingURL=index.js.map